if (!window.dAgency) window.dAgency = {};

window.dAgency.initAccordions = () => {
  class Accordion {
    constructor(el, index) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion-content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      if (!this.el.dataset.index) {
        this.el.dataset.index = new Date().getTime() + (index ? "_" + index : '');
      }
      this.dataIndex = this.el.dataset.index;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + parseInt(getComputedStyle(this.el)['padding-top'].replace('px', '')) + parseInt(getComputedStyle(this.el)['padding-bottom'].replace('px', ''))}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 800,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
      if(this.el.classList.contains('filter__disclosure')) {
        $('details.filter__disclosure[open]:not([data-index="'+this.dataIndex+'"]) summary').trigger('click');
      }
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight + parseInt(getComputedStyle(this.el)['padding-top'].replace('px', '')) + parseInt(getComputedStyle(this.el)['padding-bottom'].replace('px', ''))}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
    }
  }

  document.querySelectorAll('details').forEach((el, index) => {
    if(el.querySelector('summary') && el.querySelector('.accordion-content')) {
      new Accordion(el, index);
    }
  });
}

window.dAgency.initAccordions();
